import { createContext, useContext, useState, ReactNode } from "react";
import SystemAlert from "@View/components/ui/alert/SystemAlert";

export type AlertOptions = {
  title: string;
  text: string;
  level: "error" | "warn" | "info";
  onClose?: () => void;
};

type AlertContextType = {
  showAlert: (options: AlertOptions) => void;
};

const AlertContext = createContext<AlertContextType | null>(null);

export const useAlert = () => {
  const ctx = useContext(AlertContext);
  if (!ctx) throw new Error("useAlert must be used within AlertProvider");
  return ctx;
};

export const AlertProvider = ({ children }: { children: ReactNode }) => {
  const [alert, setAlert] = useState<AlertOptions | null>(null);

  const showAlert = (options: AlertOptions) => {
    setAlert(options);
  };

  const handleClose = () => {
    alert?.onClose?.();
    setAlert(null);
  };

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      {alert && (
        <div id="alert-root">
          <SystemAlert
            title={alert.title}
            text={alert.text}
            level={alert.level}
            onClose={handleClose}
          />
        </div>
      )}
    </AlertContext.Provider>
  );
};
